module.exports = __webpack_public_path__ + "media/images/riders/GERHARD_KERSCHBAUMER-4ef8bc1c2c2ce3b286048c4ff5ccfc73.png";